// src/components/SubscriptionRequired.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { AuthContext } from '../contexts/AuthContext';

function SubscriptionRequired({ children }) {
  const { currentUser, hasValidSubscription, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader size={50} color="#123abc" loading={loading} />
      </div>
    );
  }

  if (!currentUser) {
    // Redirect unauthenticated users to login
    return <Navigate to="/login" replace />;
  }

  if (!hasValidSubscription) {
    // If user has free subscription, let them through, otherwise redirect to marketing pricing
    const { subscriptionTier } = useContext(AuthContext);
    const hasFree = subscriptionTier === 'free';
    
    if (!hasFree) {
      // Redirect users without any subscription to the marketing site pricing section
      window.location.href = 'https://www.reelintro.com/#pricing';
      return null;
    }
  }

  return children;
}

export default SubscriptionRequired;